import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css'
import { FaBars, FaTimes } from 'react-icons/fa'

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        <img 
          src={process.env.PUBLIC_URL + '/logo.png'} 
          alt="Chatlea Logo" 
          className="logo-image" 
        />
        {/* <span>Chatlea</span> */}
      </Link>

      {/* Desktop Navigation */}
      <div className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
        <a href="#features" onClick={() => setIsMobileMenuOpen(false)}>Features</a>
        <a href="#how-it-works" onClick={() => setIsMobileMenuOpen(false)}>How It Works</a>
        <a href="#testimonials" onClick={() => setIsMobileMenuOpen(false)}>Testimonials</a>
        <Link 
          to="/chat" 
          className="nav-button mobile-nav-button"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Start Chatting
        </Link>
      </div>

      {/* Mobile Menu Button */}
      <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </nav>
  )
}

export default Navbar